const INIT_APP = 'INIT_APP';
const SET_IS_ONLINE = 'SET_IS_ONLINE';

const initApp = () => ({
  type: INIT_APP,
});

const setIsOnline = isOnline => ({
  type: SET_IS_ONLINE,
  isOnline,
});

export default {
  INIT_APP,
  initApp,
  SET_IS_ONLINE,
  setIsOnline,
};
